import styled from 'styled-components';
import { fromLarge, fromMedium } from 'styleUtils/mediaQueries';
import { gridRow, GridStartEndAttributes, gridColumn } from 'styleUtils/grid';
import { GridItem } from './GridItem';

const defaultHighlightColumn: GridStartEndAttributes = { start: 2, end: 4, ieAddEnd: -1 };
const meetRightHighlightColumn: GridStartEndAttributes = { start: 1, end: 3 };

const defaultHighlightRow: GridStartEndAttributes = { start: 1, end: 5 };
const offsetMeetHighlightRow: GridStartEndAttributes = { start: 1, end: 4 };
const hasImageHighlightRow: GridStartEndAttributes = { start: 2, end: 4 };

export const HighlightWrapper = styled.div<GridItem>`
    ${gridColumn({ start: 1 })}
    ${gridRow({ start: 1 })}

    ${fromMedium`
        ${({ meetRight }): string => {
            return gridColumn({ start: meetRight ? 1 : 2 });
        }}
    `};

    ${fromLarge`
        ${({ meetRight }): string => {
            return gridColumn(meetRight ? meetRightHighlightColumn : defaultHighlightColumn);
        }}

        ${({ hasImage, offsetMeet }): string => {
            if (hasImage) {
                return gridRow(hasImageHighlightRow);
            }

            if (offsetMeet) {
                return gridRow(offsetMeetHighlightRow);
            }

            return gridRow(defaultHighlightRow);
        }}
  `};

    text-align: justify;
`;
